import { EMPTY_OBJ, EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import useQuery from './useQuery';
import mutationFactory from './mutationFactory';

import api from '..';

export const useCountriesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'countries', api: api.countries }, queryVariables, queryConfig);

  return {
    countries: queryResult.resolvedData,
    latestCountries: queryResult.latestData,
    ...queryResult,
  };
};

export const useCountry = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['country', { id }], api.countries.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    country: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useCountriesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['countries', { ids }], api.countries.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    countries: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

const mutation = mutationFactory({ invalidate: 'countries' });

export const useDeleteCountry = mutation(api.countries.remove);
export const useCreateCountry = mutation(api.countries.create);
export const useSaveCountry = mutation(api.countries.save);
export const useUpdateCountry = mutation(api.countries.update);
